import { Injectable } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { Note } from '@app/models/note.model';
import { NameLocalStorage } from '@app/models/record.model';
import { User } from '@app/models/user.model';
import { ApiService } from '@app/services/api.service';
import { RecordService } from '@app/services/record.service';
import { defaultNote } from '@app/shared/common/utils';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { DataSelectors } from '@app/store/data/data.selectors';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';
import { EMPTY, mergeMap, Observable, of } from 'rxjs';

interface Record {
  user: User;
  items: Note[];
}

@Injectable({
  providedIn: 'root',
})
export class RecordAddResolverService implements Resolve<Record> {
  constructor(
    private store: Store,
    private apiService: ApiService,
    private recordService: RecordService,
  ) { }
  resolve(): Observable<Record> {
    let selected = this.store.selectSnapshot(SettingSelectors.selectedTitles);
    if (!selected) {
      selected = JSON.parse(localStorage.getItem(NameLocalStorage.SELECTED_TITLES) ?? '');
    }
    const { objcd, items } = selected!;
    let _objectcd = this.store.selectSnapshot(AuthSelectors.objectcd) || localStorage.getItem('objectcd') || '';
    const userList = this.store.selectSnapshot(DataSelectors.userList(_objectcd));
    if (!userList) return EMPTY;
    const user = userList.find((user) => user.daicd === objcd);
    if (items.length === 0) return of({ user: user!, items: [] });
    const payload = {
      sdate: new Date(),
      objcd: user!.daicd,
      titleSetKeys: this.recordService.getTitleSetKeys(items),
    };
    return this.apiService.getNoteListDefault(payload).pipe(
      mergeMap((res) => {
        if (!res) return EMPTY;
        if (!res.length) {
          return of({
            user: user!,
            items: items.map(x => {
              const note = defaultNote(x.ttlkbn, x.ttlcd, user!)
              return { ...note, delstat: 0, lockflg: 0 }
            }) as any[]
          })
        }
        return of({
          user: user!,
          items: res.map((note) => ({ ...note, delstat: 0, lockflg: 0 })),
        });
      })
    );
  }
}
